import { data } from '@/util/cityData'
import { cloneDeep } from 'lodash'

export const to = (href, name = '_blank') => {
  window.open(href, name)
}

export const renderArea = (data) =>
  [data?.province, data?.city, data?.district].filter((o) => o)

export const formatArea = (code) => {
  let d = data,
    res = [],
    va = cloneDeep(code)
  while (va.length) {
    const cur = va.shift()
    const curData = d.find((item) => item.value === cur)
    if (curData) {
      d = curData.children
      res.push(curData.label)
    }
  }
  return res.join(' / ')
}
